import { createAuthClient } from "better-auth/react";

/**
 * Better-auth client for frontend authentication.
 *
 * In development, Vite proxies /api requests to the backend (localhost:3001).
 * In production, the frontend and API typically share the same origin.
 *
 * The client automatically handles:
 * - Session cookie management
 * - Reactive session state via useSession hook
 * - Sign in/out operations
 */
export const authClient = createAuthClient({
  // Auth endpoints are mounted at /api/auth in the NestJS backend
  // Vite proxy handles forwarding to backend in development
  baseURL: `${window.location.origin}/api/auth`,
});

// Export auth hooks and methods for use in components
export const {
  useSession,
  signIn,
  signUp,
  signOut,
} = authClient;

// Export types for type safety
export type Session = typeof authClient.$Infer.Session;
export type User = typeof authClient.$Infer.Session.user;
